import React, { Fragment, useState, useEffect } from "react";
import API from "@unisearch/helpers/api";
import { Grid, Skeleton } from "@mui/material";

import { htmlParse, isEmpty } from "@unisearch/helpers";
import { ReactSVG } from "react-svg";
import { numFormatter } from "@unisearch/helpers";
import styles from "./uni_overview.module.scss";
import { UniOverviewAccomodation } from "../template_two";

export const UniOverview = ({ universityProfileData }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await API.get(
          `/public/university-overview/info/${universityProfileData?.universityId}`
        );
        setLoading(false);
        setData(res.data);
      } catch (error) {
        setLoading(false);
        setError("Something went wrong");
      }
    };
    fetchData();
  }, []);

  return (
    <Fragment>
      {isEmpty(data) ? (
        <></>
      ) : (
        <>
          <section className={styles.section_overview}>
            <div className="container from_texteditor_wrapper">
              {/* highllights */}
              {data?.highlight && (
                <div
                  className={`${styles.uni_overview_sec_wrapper} ${styles.highlights}`}
                >
                  <h2>University Highlights</h2>
                  {data ? htmlParse(data?.highlight) : ""}
                </div>
              )}

              {/* University at a Glance */}
              <div className={styles.uni_overview_sec_wrapper}>
                <h2>University at a Glance</h2>
                <ul className={styles.uni_ata_glance_list}>
                  {data?.internationalStudents &&
                  data?.internationalStudents != 0 ? (
                    <li>
                      <ReactSVG src="/assets/images/uni-profile/international-students.svg" />
                      <span className={styles.uni_list_name}>
                        International <br /> Students
                      </span>
                      <span className={styles.uni_list_ratio}>
                        {data?.internationalStudents}
                      </span>
                    </li>
                  ) : (
                    ""
                  )}
                  {data?.maleFemaleRatio && data?.maleFemaleRatio != 0 ? (
                    <li>
                      <ReactSVG src="/assets/images/uni-profile/male-female-ratio.svg" />
                      <span className={styles.uni_list_name}>
                        Male/Female <br /> Ratio
                      </span>
                      <span className={styles.uni_list_ratio}>
                        {data?.maleFemaleRatio}
                      </span>
                    </li>
                  ) : (
                    ""
                  )}
                  {data?.ugPgRatio && data?.ugPgRatio != 0 ? (
                    <li>
                      <ReactSVG src="/assets/images/uni-profile/ug-pg-course-ratio.svg" />
                      <span className={styles.uni_list_name}>
                        UG/PG Course <br /> Ratio
                      </span>
                      <span className={styles.uni_list_ratio}>
                        {data?.ugPgRatio}
                      </span>
                    </li>
                  ) : (
                    ""
                  )}
                  {data?.facultyRatio && data?.facultyRatio != 0 ? (
                    <li>
                      <ReactSVG src="/assets/images/uni-profile/faculty-student-ratio.svg" />
                      <span className={styles.uni_list_name}>
                        Faculty/Student <br /> Ratio
                      </span>
                      <span className={styles.uni_list_ratio}>
                        {data?.facultyRatio}
                      </span>
                    </li>
                  ) : (
                    ""
                  )}
                  {data?.noOfCampus && data?.noOfCampus != 0 ? (
                    <li>
                      <ReactSVG src="/assets/images/uni-profile/noof-campuses.svg" />
                      <span className={styles.uni_list_name}>
                        No. of <br /> Campuses
                      </span>
                      <span className={styles.uni_list_ratio}>
                        {data?.noOfCampus}
                      </span>
                    </li>
                  ) : (
                    ""
                  )}
                  {data?.yearlyHotelMealExpenseFrom &&
                  data?.yearlyHotelMealExpenseFrom != 0 ? (
                    <li>
                      <ReactSVG src="/assets/images/uni-profile/yearly-expense.svg" />
                      <span className={styles.uni_list_name}>
                        Yearly Hostel & <br /> Meals Expense
                      </span>
                      <span className={styles.uni_list_ratio}>
                        {data?.countryCurrencySymbol}
                        {numFormatter(data?.yearlyHotelMealExpenseFrom)}

                        {data?.yearlyHotelMealExpenseTo != 0 &&
                          data?.yearlyHotelMealExpenseTo &&
                          " - "}

                        {data?.yearlyHotelMealExpenseTo != 0 &&
                          numFormatter(data?.yearlyHotelMealExpenseTo)}
                      </span>
                    </li>
                  ) : (
                    ""
                  )}
                </ul>
              </div>
              {data?.overview && (
                <div
                  className={`${styles.uni_overview_sec_wrapper} ${styles.overview}`}
                >
                  <h2>Overview</h2>
                  {data?.overview ? htmlParse(data?.overview) : ""}
                </div>
              )}
            </div>
          </section>

          <UniOverviewAccomodation
            overviewData={data}
            universityProfileData={universityProfileData}
          />
        </>
      )}
    </Fragment>
  );
};

export default UniOverview;
